import React, { useContext, useEffect, useState } from 'react';
import apiMethods from '../../apis';
import useGet from '../../services/hooks/http/useGet';

import classes from './AddAgreement.module.scss';
import Categories from './Categories/Categories';
import FormAgreement from './FormAgreement/FormAgreement';
import Context from '../../store/context';

const categoriasDummy = [
  {
    id: 4,
    name: 'ACUEDUCTO',
    description: 'ACUEDUCTO'
  },
  {
    id: 9,
    name: 'AEROLINEAS Y AGENCIAS DE VIAJES',
    description: 'AEROLINEAS Y AGENCIAS DE VIAJES'
  },
  {
    id: 5,
    name: 'ASEO',
    description: 'ASEO'
  },
  {
    id: 10,
    name: 'CAJAS DE COMPENSACION',
    description: 'CAJAS DE COMPENSACION'
  },
  {
    id: 27,
    name: 'CAMARA DE COMERCIO',
    description: 'CAMARA DE COMERCIO'
  },
  {
    id: 12,
    name: 'COMERCIOS/DISTRIBUIDORAS',
    description: 'COMERCIOS/DISTRIBUIDORAS'
  },
  {
    id: 13,
    name: 'CONJUNTOS RESIDENCIALES',
    description: 'CONJUNTOS RESIDENCIALES'
  },
  {
    id: 14,
    name: 'COOPERATIVAS',
    description: 'COOPERATIVAS'
  },
  {
    id: 6,
    name: 'ENERGIA',
    description: 'ENERGIA'
  },
  {
    id: 28,
    name: 'ENTIDADES GUBERNAMENTALES',
    description: 'ENTIDADES GUBERNAMENTALES'
  },
  {
    id: 16,
    name: 'FONDOS/FUNDACIONES',
    description: 'FONDOS/FUNDACIONES'
  },
  {
    id: 17,
    name: 'FUNERARIAS',
    description: 'FUNERARIAS'
  },
  {
    id: 7,
    name: 'GAS',
    description: 'GAS'
  },
  {
    id: 3,
    name: 'GOBIERNO/ESTADO',
    description: 'GOBIERNO/ESTADO'
  },
  {
    id: 18,
    name: 'IGLESIAS',
    description: 'IGLESIAS'
  },
  {
    id: 29,
    name: 'IMPUESTOS',
    description: 'IMPUESTOS'
  },
  {
    id: 19,
    name: 'INMOBILIARIA',
    description: 'INMOBILIARIA'
  },
  {
    id: 11,
    name: 'INSTITUCIONES EDUCATIVAS/COLEGIOS',
    description: 'INSTITUCIONES EDUCATIVAS/COLEGIOS'
  },
  {
    id: 20,
    name: 'LOTERIAS',
    description: 'LOTERIAS'
  },
  {
    id: 30,
    name: 'MULTISERVICIOS',
    description: 'MULTISERVICIOS'
  },
  {
    id: 31,
    name: 'OTROS',
    description: 'OTROS'
  },
  {
    id: 15,
    name: 'PERIODICOS/REVISTAS',
    description: 'PERIODICOS/REVISTAS'
  },
  {
    id: 22,
    name: 'SALUD/MEDICINA PREPAGADA/PILA',
    description: 'SALUD/MEDICINA PREPAGADA/PILA'
  },
  {
    id: 21,
    name: 'SEGUROS',
    description: 'SEGUROS'
  },
  {
    id: 25,
    name: 'SERVICIO DE TRANSPORTE',
    description: 'SERVICIO DE TRANSPORTE'
  },
  {
    id: 23,
    name: 'SERVICIOS FINANCIEROS',
    description: 'SERVICIOS FINANCIEROS'
  },
  {
    id: 2,
    name: 'SERVICIOS PRIVADOS',
    description: 'SERVICIOS PRIVADOS'
  },
  {
    id: 1,
    name: 'SERVICIOS PUBLICOS',
    description: 'SERVICIOS PUBLICOS'
  },
  {
    id: 8,
    name: 'TELEFONIA FIJA',
    description: 'TELEFONIA FIJA'
  },
  {
    id: 24,
    name: 'TELEFONIA MOVIL/TV POR SUSCRIPCION',
    description: 'TELEFONIA MOVIL/TV POR SUSCRIPCION'
  },
  {
    id: 26,
    name: 'VALORES Y VIGILANCIA',
    description: 'VALORES Y VIGILANCIA'
  }
];

const AddAgreement = () => {
  const [categories, setCategories] = useState([]);
  const [categorySelected, setCategorySelected] = useState(null);

  const [currentState, setCurrentState] = useState(0);

  const {
    modal: { showError }
  } = useContext(Context);

  const {
    isSuccess: categoryIsSuccess,
    data: categoryItems,
    isError: categoryIsError,
    errorMessage: errorMessageGetAggrement
  } = useGet(apiMethods.getAgreementsCategories, []);

  useEffect(() => {
    if (categoryIsSuccess) {
      setCategories(
        categoryItems
          .map(category => ({ label: category.categoryName, value: category.categoryId }))
          .concat({
            label: 'Ventas por catálogo',
            value: 'CATALOGS_SELLS'
          })
      );
      /*  setCategories(
        Object.keys(AgreementIcons).map(agreementValue => ({ label: AgreementIcons[agreementValue].label, value: agreementValue }))
      ); */
    } else if (categoryIsError) {
      showError({ title: 'Categorias', description: errorMessageGetAggrement });
    }
  }, [showError, categoryIsError, categoryIsSuccess, categoryItems, errorMessageGetAggrement]);

  const nextHandler = () => {
    if (currentState === 0) setCurrentState(current => current + 1);
  };

  const clickBack = () => {
    setCurrentState(current => current - 1);
  };

  return (
    <div className={classes.content}>
      {currentState === 0 && (
        <Categories
          nextHandler={nextHandler}
          setCategorySelected={setCategorySelected}
          categorySelected={categorySelected}
          categories={categories}
        />
      )}
      {currentState === 1 && <FormAgreement clickBack={clickBack} categorySelected={categorySelected} />}
    </div>
  );
};

export default AddAgreement;
